export default class Head {

    static addHeadLink(p) {
        
        const link = document.createElement("link")

        Object.entries(p).forEach(([name, value]) => {
            link[name] = value
        })
        
        document.head.appendChild(link)
        return link
    }

    static setFavIcon(pIconURL) {

        if(!pIconURL) {
            return
        }
    
        this.addHeadLink({
            rel: "icon",
            sizes: "180x180",
            href: pIconURL
        })

        this.addHeadLink({
            rel: "apple-touch-icon",
            href: pIconURL
        })
    }
}